var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon":"","variant":"link","size":"sm"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{staticClass:"font-size-16",attrs:{"variant":"primary","icon":"arrow-counterclockwise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }